import { Row } from "antd";
import { Col } from "react-bootstrap";
import { MesCompetencia } from "shared/components/date/MesCompetencia";
import InputSearch from "shared/components/input/InputSearch";
import CustomModal from "shared/components/modal/CustomModal";
import ScrollElement from "shared/components/scrollElement/ScrollElement";
import CustomButton from "shared/components/button/CustomButton";
import { DespesaGroupPayDetalhada } from "types/response/groupPay/DespesaGroupPayDetalhadaResponse";
import { useContext, useEffect, useState } from "react";
import { useGetRegistrosContasPagarTabelaGroupPay } from "hooks/contasPagar/useGetRegistrosContasPagarTabelaGroupPay";
import { RegistroContaPagarTabelaGroupPay } from "types/contasPagar/RegistroContaPagarTabelaGroupPay";
import { Tabela } from "shared/components/table/Tabela";
import RenderRowsTabelaModalVincularDespesasGroupPay from "./RenderRowsTabelaModalVincularDespesasGroupPay";
import { TableColumn } from "types/table/TableColumn";
import { UserContext } from "context/UserContext";
import { formatarDataParaGetRequest } from "shared/util/functions/formatacoesDeValores/FormatarValores";
import showAlert from "shared/util/functions/alert/showAlert";
import { usePostVincularDespesaGroupPay } from "hooks/groupPay/usePostVincularDespesaGroupPay";
import { possuiMensagemDeErro } from "shared/util/functions/errors/RequestPossuiMensagemDeErro";
import toast from "react-hot-toast";
import { getMensagemDeErroBackend } from "shared/util/functions/errors/GetMensagemDeErroBackend";
import { BuscarDespesaGroupPayResponse } from "types/response/groupPay/BuscarDespesaGroupPayResponse";

interface ModalVincularDespesaGroupPayProps {
  despesaGroupPaySelecionada: BuscarDespesaGroupPayResponse;
  showModal: boolean;
  onCloseModal: () => void;
  isFluxoVinculoAutomatico: boolean;
  setIsFluxoVinculoAutomatico: (isFluxoVinculoAutomatico: boolean) => void;
}

const ModalVincularDespesaGroupPay: React.FC<ModalVincularDespesaGroupPayProps> = (props) => {
  const { competenciaSelecionada } = useContext(UserContext);
  const [isBuscaManual, setIsBuscaManual] = useState(false);

  const [ordenacaoAscOuDesc, setOrdenacaoAscOuDesc] = useState<"ASC" | "DESC">("ASC");
  const [sortString, setSortString] = useState<string>("");
  const [ordenarPorColuna, setOrdenarPorColuna] = useState<string>("");
  const [paginaAtual, setPaginaAtual] = useState(1);
  const [pesquisa, setPesquisa] = useState(props.despesaGroupPaySelecionada?.nomeEmissor);
  const [cpfCnpjEmissor, setCpfCnpjEmissor] = useState(props.despesaGroupPaySelecionada?.cpfCnpjEmissor);
  const [valor, setValor] = useState(() =>
    props.despesaGroupPaySelecionada?.valor != null
      ? String(props.despesaGroupPaySelecionada.valor)
      : ""
  );
  const [dataVencimento, setDataVencimento] = useState(
    props.despesaGroupPaySelecionada?.dataVencimento
      ? formatarDataParaGetRequest(new Date(props.despesaGroupPaySelecionada.dataVencimento))
      : ""
  );
  const [idContasPagarSelecionada, setIdContasPagarSelecionada] = useState<number>();
  const [mesCompetencia, setMesCompetencia] = useState<Date | null>(() => {
    const dataInicial = competenciaSelecionada ? new Date(competenciaSelecionada) : new Date();
    dataInicial.setDate(1);

    return dataInicial;
  });

  const parametrosPesquisa = {
    page: paginaAtual - 1,
    size: 10,
    sort: sortString,
    pesquisa: pesquisa,
    mesCompetencia: formatarDataParaGetRequest(mesCompetencia),
    cpfCnpjEmissor: cpfCnpjEmissor,
    dataVencimento: isBuscaManual ? "" : dataVencimento,
    valor: isBuscaManual ? "" : valor,
    condominioId: props.despesaGroupPaySelecionada.condominioId?.toString(),
  };

  const deveBuscarRegistros = (pesquisa !== "" || mesCompetencia !== null) && props.showModal;

  const { data: retornoApi, isLoading } = useGetRegistrosContasPagarTabelaGroupPay(parametrosPesquisa, deveBuscarRegistros);

  const { mutateAsync: vincularDespesaNoGroupPay } = usePostVincularDespesaGroupPay();

  const limparfiltros = () => {
    setOrdenacaoAscOuDesc("ASC");
    setSortString("");
    setOrdenarPorColuna("");
    setPaginaAtual(1);
    setPesquisa("");
    setIdContasPagarSelecionada(undefined);
    setMesCompetencia(null);
    setValor("");
    setDataVencimento("");
    setCpfCnpjEmissor("");
  }

  useEffect(() => {
    if (props.showModal) {
      setIsBuscaManual(false);

      setPesquisa(props.despesaGroupPaySelecionada?.nomeEmissor);
      setCpfCnpjEmissor(props.despesaGroupPaySelecionada?.cpfCnpjEmissor);
      setValor(
        props.despesaGroupPaySelecionada?.valor != null
          ? String(props.despesaGroupPaySelecionada.valor)
          : ""
      );
      setDataVencimento(
        props.despesaGroupPaySelecionada?.dataVencimento
          ? formatarDataParaGetRequest(new Date(props.despesaGroupPaySelecionada.dataVencimento))
          : ""
      );

      const dataInicialCompetencia = competenciaSelecionada ? new Date(competenciaSelecionada) : new Date();
      dataInicialCompetencia.setDate(1);
      setMesCompetencia(dataInicialCompetencia);
      setIdContasPagarSelecionada(undefined);
      setPaginaAtual(1);
    }
  }, [props.despesaGroupPaySelecionada, props.showModal]);

  const handlePesquisaChange = (novoValor: string) => {
    setIsBuscaManual(true);
    setPesquisa(novoValor);
    setCpfCnpjEmissor("")
    setPaginaAtual(1);
  };

  const handleCompetenciaChange = (date: Date | null) => {
    if (date === null || isNaN(date.getTime())) {
      setMesCompetencia(null);
      return;
    }
    setIsBuscaManual(true);
    setPaginaAtual(1);

    const novaData = new Date(date);
    novaData.setDate(1);
    setMesCompetencia(novaData);
  };

  const renderContentModalVincularDespesa = () => {
    return (
      <div>
        <h2 className="p-2">Vincular despesas</h2>
        {renderFiltroVincularDespesas()}
        <ScrollElement height="55vh">{renderTabelaVincularDespesas()}</ScrollElement>
      </div>
    );
  };

  const renderFiltroVincularDespesas = () => {
    return (
      <Row className="mb-3">
        {renderCampoBusca()}
        {renderCampoCompetencia()}
      </Row>
    );
  };

  const renderCampoBusca = () => {
    return (
      <Col xs={6} className="me-4">
        <InputSearch
          id="pesquisa-depesas-group-pay"
          label="Buscar"
          value={pesquisa}
          defaultValue={props.isFluxoVinculoAutomatico ? "" : pesquisa}
          placeholder="Buscar por classe de conta, número do documento ou fornecedor"
          onSearchChange={handlePesquisaChange}
        />
      </Col>
    );
  };

  const renderCampoCompetencia = () => {
    return (
      <Col xs={2}>
        <MesCompetencia
          usarValidacaoParaFormulario={false}
          label="Competência"
          value={props.isFluxoVinculoAutomatico ? null : mesCompetencia || null}
          defaultValue={props.isFluxoVinculoAutomatico ? undefined : mesCompetencia || undefined}
          onChange={handleCompetenciaChange}
        />
      </Col>
    );
  };

  const getTextoAlertaDocumentoJaVinculado = (nomeArquivo: string) => {
    return (
      `Esta despesa já possui documento vinculado.\n` +
      `Arquivo vinculado:\n` +
      `${nomeArquivo}\n` +
      `Deseja vincular este novo documento mesmo assim?`
    );
  };

  const confirmarVinculo = async () => {
    if (!idContasPagarSelecionada) {
      return;
    }

    await vincularDespesaNoGroupPay({
      idContasPagar: idContasPagarSelecionada.toString(),
      uuidDespesaNoGroupPay: props.despesaGroupPaySelecionada.uuidDespesaNoGroupPay,
    })
      .then(() => {
        fecharModal();
      })
      .catch((error) =>
        possuiMensagemDeErro(error)
          ? toast.error(getMensagemDeErroBackend(error))
          : toast.error("Erro ao vincular despesa")
      );
  };

  const vincularDespesa = async () => {
    if (!idContasPagarSelecionada) {
      return;
    }

    const registroSelecionado = (retornoApi?.content as RegistroContaPagarTabelaGroupPay[] | undefined)?.find(
      (registro) => registro.id === idContasPagarSelecionada
    );

    if (registroSelecionado?.nomeArquivoVinculado) {
      showAlert({
        texto: getTextoAlertaDocumentoJaVinculado(registroSelecionado.nomeArquivoVinculado),
        tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
        labelBotaoCancelar: "Cancelar",
        labelBotaoConfirmar: "Vincular mesmo assim",
        onConfirm: () => {
          confirmarVinculo();
        },
      });
      return;
    }

    await confirmarVinculo();
  };

  const renderCustomFooter = () => {
    return (
      <div className="d-flex align-items-center justify-content-between w-100">
        <div>{renderBotaoLimparFiltros()}</div>
        <div>
          <CustomButton
            id="btn-cancelar"
            label="Cancelar"
            onClick={() => closeModal()}
            variant="danger-alt"
            className="me-2"
          />
          <CustomButton
            id="btn-vincular-despesa"
            variant="primary"
            label="Vincular"
            onClick={() => vincularDespesa()}
          />
        </div>
      </div>
    );
  };

  const renderBotaoLimparFiltros = () => {
    const isFiltrosLimpos = pesquisa === "" && mesCompetencia === null;

    return (
      <div
        className={`${isFiltrosLimpos ? "botao-sublinhado-inativo" : "botao-sublinhado-ativo"}`}
        onClick={() => {
          limparfiltros()
        }
        }
      >
        Limpar filtro
      </div>
    );
  };

  const createColumns = (): TableColumn[] => {
    return [
      {
        id: "vincular",
        label: "Vincular",
        isOrdenavel: false,
        width: "85px",
      },
      {
        id: "classeConta",
        label: "Classe de conta",
        isOrdenavel: false,
        width: "180px",
      },
      {
        id: "fornecedor",
        label: "Fornecedor",
        width: "180px",
      },
      {
        id: "mesCompetencia",
        label: "Competência",
        isOrdenavel: true,
        width: "140px",
      },
      {
        id: "numeroDocumento",
        label: "Número do documento",
        isOrdenavel: true,
        width: "215px",
      },
      {
        id: "dataVencimento",
        label: "Vencimento",
        isOrdenavel: true,
        width: "130px",
      },
      {
        id: "valorLiquido",
        label: "Valor líquido",
        isOrdenavel: true,
        width: "135px",
      },
    ];
  };

  const ordenarRegistros = (idColuna: string) => {
    const novaOrdenacao =
      !ordenacaoAscOuDesc || ordenarPorColuna !== idColuna || ordenacaoAscOuDesc === "DESC" ? "ASC" : "DESC";
    setOrdenacaoAscOuDesc(novaOrdenacao);
    setOrdenarPorColuna(idColuna);
    setSortString(`${idColuna},${novaOrdenacao}`);
  };

  const renderTabelaVincularDespesas = () => {
    let qtdRegistros = retornoApi?.totalElements as number;
    let qtdPaginas = retornoApi?.totalPages as number;
    let registros = retornoApi?.content as RegistroContaPagarTabelaGroupPay[];

    return (
      <Tabela
        id="tabela-modal-vincular-despesas-group-pay"
        colunas={createColumns()}
        ordernarPorColuna={ordenarPorColuna}
        ordenacaoAscOuDesc={ordenacaoAscOuDesc}
        ordenarRegistrosFunction={(idColuna) => ordenarRegistros(idColuna)}
        onChangePageFunction={(paginaAtual: number) => setPaginaAtual(paginaAtual)}
        paginaAtual={paginaAtual}
        quantidadeDePaginas={qtdPaginas}
        renderCheckBox={false}
        isLoading={isLoading}
        quantidadeDeRegistros={qtdRegistros}
      >
        <RenderRowsTabelaModalVincularDespesasGroupPay
          onSelecionarDespesa={(registro: RegistroContaPagarTabelaGroupPay) => {
            setIdContasPagarSelecionada(registro.id);
          }}
          registros={registros}
        />
      </Tabela>
    );
  };

  const closeModal = () => {
    if (idContasPagarSelecionada) {
      showAlert({
        texto: "Existem alterações que não foram salvas na tela. Tem certeza de que deseja sair sem salvar?",
        tipoAlerta: "CONFIRMAR_CANCELAR_ALERT",
        onConfirm: () => {
          fecharModal();
        },
      });
    } else {
      fecharModal();
    }
  };

  const fecharModal = () => {
    props.onCloseModal();
  };

  return (
    <CustomModal
      key={"modal-vincular-despesa-group-pay"}
      showModal={props.showModal}
      tipoModal="MODAL_CENTRAL"
      size="xl"
      renderHeaderModal={false}
      onCloseModal={closeModal}
      customFooter={renderCustomFooter()}
    >
      {renderContentModalVincularDespesa()}
    </CustomModal>
  );
};

export default ModalVincularDespesaGroupPay;
